<template>
    <div class="VolunteersTable">
        <table>
            <thead>
            <tr>
                <th>{{ translates.rating }}</th>
                <th>{{ translates.volunteer }}</th>
                <th>{{ translates.directions }}</th>
                <th>{{ translates.projects }}</th>
                <th>{{ translates.hours }}</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item, key) in mixItems" :key="key">
              <tr v-if="item.id">
                <td colspan="6">
                  <AppSection>
                    <template #body>
                      <StoryCard v-bind="item"/>
                    </template>
                  </AppSection>
                </td>
              </tr>
              <VolunteerTableItem v-else  v-bind="item"/>
            </template>
            </tbody>
        </table>

    </div>
</template>

<script>
import {inject, computed} from "vue";
import AppSection from "../../components/AppSection";
import VolunteerTableItem from "./VolunteerTableItem";
import StoryCard from "../../components/cards/StoryCard";

export default {
    name: "VolunteersTable",
    props: {
        list: Array,
        banner: Object,
    },
    components: {VolunteerTableItem,AppSection,StoryCard},
    setup(props) {
        const translates = inject('translates', {});
        const mixItems  = computed(() => {
          let index = 0;
          let res = [];
          for(let listIndex in props.list) {
            if(typeof props.list[listIndex]=='object') {
              index++;
              res.push(props.list[listIndex]);
              if(index==props?.banner?.after&&props?.banner?.body?.length>0) {
                res.push(props?.banner?.body);
              }
            }

          }
          return res;
        });

        return {
          translates,
          mixItems
        }
    }
}
</script>

<style scoped lang="scss">
table {
    height: 100%;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 1em;

    @include mobile {
        display: flex;
        flex-direction: column;
    }

    th {
        text-align: left;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: var(--c-gray-500);
      min-width: 95px;
        @include mobile {
            display: none;
        }
    }
}
</style>